/**
 * Create Bookings context for custom hook
 */
import { createContext } from 'react'

const BookingsContext = createContext({
  createBookingCancel: () => {},
  fetchBookings: () => {},
  fetchBookingsAll: () => {},
  fetchBooking: () => {},
})

export default BookingsContext
